import React from "react";
import { Builder } from '@builder.io/react';

const VideoPlaylist = ({ urls = [] }) => {
  if (!urls.length) return null;
  return (
    <div className="w-full flex flex-col md:flex-row flex-wrap justify-center items-center bg-[#E1EFF1]">
      {urls.map((item, idx) => (
        <iframe
          key={item.url + idx}
          className="px-4"
          width="329"
          height="168"
          src={item.url}
          title={`YouTube video player ${idx + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      ))}
    </div>
  );
};

Builder.registerComponent(VideoPlaylist, {
  name: 'VideoPlaylist',
  inputs: [
    {
      name: 'urls',
      type: 'list',
      defaultValue: [],
      subFields: [
        { name: 'url', type: 'string', defaultValue: '' }
      ]
    }
  ]
});

export default VideoPlaylist;